import { Pagination } from 'antd';
import { usePayoutInvoicesTableStore } from 'store/payoutInvoicesTable';
import { usePayoutInvoicesTableFiltersStore } from 'store/payoutInvoicesTableFilters';
import { LocalizedConfigProvider } from 'ui/LocalizedConfigProvider';
import type { TComponent } from 'utils/types/component';

export const CustomPagination: TComponent = () => {
    const params = usePayoutInvoicesTableFiltersStore('params');
    const body = usePayoutInvoicesTableFiltersStore('body');
    const totalElements = usePayoutInvoicesTableStore('totalElements');

    const setParams = usePayoutInvoicesTableFiltersStore('setParams');
    const getTable = usePayoutInvoicesTableStore('getTable');

    const page = params.page + 1;

    const handleChangePage = (currentPage: number, pageSize: number) => {
        const enhancePage = currentPage - 1;

        const newParams = { ...params, page: enhancePage, size: pageSize };

        setParams(newParams);
        getTable(body, newParams);
    };

    return (
        <LocalizedConfigProvider>
            <Pagination
                showSizeChanger
                current={page}
                total={totalElements}
                onChange={handleChangePage}
            />
        </LocalizedConfigProvider>
    );
};
